import React from 'react';
import { useQuery } from '@apollo/client';
import ActiveProductsQuery from './ActiveProductsQuery';
import type { ActiveProductsData } from '../types';

export interface ActiveProductsResult {
  loading: boolean;
  error: boolean;
  data: ActiveProductsData | null;
  refetch: () => void;
}

interface Props {
  children: (result: ActiveProductsResult) => React.ReactElement;
}

const ActiveProductsConnectorApollo: React.FC<Props> = ({ children }) => {
  const { loading, data, error, refetch } = useQuery<{ me: ActiveProductsData }>(
    ActiveProductsQuery,
    {
      // Access state changes outside the app (store renewals, Stripe portal), so always
      // revalidate while still showing cached data instantly.
      fetchPolicy: 'cache-and-network',
    }
  );

  return children({
    loading: loading && !data,
    error: Boolean(error),
    data: data?.me ?? null,
    refetch,
  });
};

export default ActiveProductsConnectorApollo;
